<app-breadcrumb [styleBreadcrumb]="'page-heading'" [title]="'COMMUNITY-SERVICE-CATEGORIES'" [breadcrumb]="''"
    [count]="count" icon="fa-cog">
</app-breadcrumb>
<div class="content-background">
    <div class="row">
        <div class="col-sm-12">
            <div class="inputWithIcon inputWithIcon-search float-right d-flex">
                <app-advanced-mode id="communityServiceCategoryGridAdvancedSwitch"
                    [storageKey]="'community-service-categories-list'" (collapsibleToggle)="enableAdvanced=$event">
                </app-advanced-mode>
                <input #search kendoTextBox class="ml-4 button-search" placeholder="{{ 'SEARCH-NAME' | translate }}"
                    (keyup)="searchFieldChange(search.value)" title="{{ 'SEARCH-NAME' | translate }}" />
                <i class="fa fa-search fa-lg fa-fw fa-search-icon"></i>
            </div>
        </div>
    </div>
    <div class="mt-3">
        <kendo-grid [data]="view.gridData" [loading]="view.loading" [navigable]="true"
            [pageable]="count > view.state.take ? { buttonCount: 5, pageSizes: pageSizes} : false"
            [pageSize]="view.state.take" [skip]="view.state.skip" [sortable]="{allowUnsort: true, mode: 'multiple'}"
            [sort]=" view.state.sort" [filterable]="enableAdvanced" [filter]="view.state.filter"
            [groupable]="enableAdvanced" [group]="view.groups" [selectable]="{ mode: 'single' }"
            [columnMenu]="enableAdvanced" [resizable]="true" [reorderable]="enableAdvanced"
            (groupChange)="groupChange($event)" (dataStateChange)="dataStateChange($event)">
            <kendo-grid-messages noRecords="{{ 'NO-COMMUNITY-SERVICE-CATEGORIES' | translate }}">
            </kendo-grid-messages>
            <kendo-grid-column field="serviceType.displayName" [width]="25"
                title="{{ 'COMMUNITY-SERVICE-TYPE' | translate }}">
            </kendo-grid-column>
            <kendo-grid-column field="name" [width]="25" title="{{ 'COMMUNITY-SERVICE-CATEGORY' | translate }}"></kendo-grid-column>
            <kendo-grid-column class="text-center" field="active" [width]="10" title="{{ 'ENABLED' | translate }}"
                filter="boolean">
                <ng-template kendoGridCellTemplate let-dataItem>
                    <i *ngIf="dataItem.active" class="fas fa-check"></i>
                </ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="lastModifiedBy" [width]="15" title="{{ 'LAST-MODIFIED-BY' | translate }}">
            </kendo-grid-column>
            <kendo-grid-column field="lastModifiedDate" [width]="15" title="{{ 'LAST-MODIFIED-DATE' | translate }}"
                filter="date" format="{0:g}"></kendo-grid-column>
            <kendo-grid-command-column [width]="10" title="{{ 'ACTIONS' | translate }}" class="text-center">
                <ng-template kendoGridCellTemplate let-dataItem>
                    <i class="fas fa-edit fa-lg" title="{{ 'EDIT' | translate }}" (click)="editHandler(dataItem['id'])">
                    </i>
                    &nbsp;
                    <i class="fas fa-trash-alt fa-lg" title="{{ 'DELETE' | translate }}"
                        (click)="deleteHandler(dataItem['id'])">
                    </i>
                </ng-template>
            </kendo-grid-command-column>
        </kendo-grid>
        <button kendoButton [primary]="false" type="button" class="float-right mt-3 mb-3" (click)="addHandler()">
            {{'ADD' | translate}}<i class="far fa-plus"></i>
        </button>
    </div>
</div>

<!--Add/Edit form-->
<app-community-service-category-edit [model]="editDataItem" [isNew]="isNew" (save)="saveChangesHandler($event)"
    (cancelling)="cancelChangesHandler()">
</app-community-service-category-edit>

<!--Delete confirmation-->
<kendo-dialog title="{{ 'PLEASE-CONFIRM' | translate }}" *ngIf="deleteDialogOpened" (close)="close('deleteDialog')"
    [minWidth]="250" [width]="450">
    <p>{{ 'CONFIRM-DELETION' | translate }}</p>
    <span class="k-font-weight-bold">{{selectedCategory.name}}</span>
    <kendo-dialog-actions>
        <button kendoButton (click)="deleteAction(false)">{{ 'NO' | translate }}</button>
        <button appPreventClick kendoButton (click)="deleteAction(true)" [primary]="true">{{ 'YES' | translate
            }}</button>
    </kendo-dialog-actions>
</kendo-dialog>